import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {AddPageOptions} from '@Components/poster-editor/components/add-new-page-button/add-new-page-button.types';
import {isMyDesignsHidden, isTemplatesPopupHidden} from '@Components/poster-editor/library/poster-editor-library';

export const getAddPageOptionItems = (order: AddPageOptions[]): ControlledListItemType[] => {
  const items: ControlledListItemType[] = [];
  for (const option of order) {
    const item = buildOptionItem(option);
    if (item !== null) {
      items.push(item);
    }
  }
  return items;
};

const buildOptionItem = (option: AddPageOptions): ControlledListItemType | null => {
  switch (option) {
    case AddPageOptions.NEW_PAGE:
      return {
        id: AddPageOptions.NEW_PAGE,
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-pages',
        text: window.i18next.t('pmwjs_blank_page'),
      };
    case AddPageOptions.TEMPLATE:
      if (isTemplatesPopupHidden()) return null;
      return {
        id: AddPageOptions.TEMPLATE,
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-multiple-layouts',
        text: window.i18next.t('pmwjs_templates'),
        textClasses: 'capitalize-sentence',
      };
    case AddPageOptions.DESIGN:
      if (isMyDesignsHidden()) return null;
      return {
        id: AddPageOptions.DESIGN,
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-designs',
        text: window.i18next.t('pmwjs_my_designs'),
      };
  }
};
